import { Component } from '@angular/core';
interface Image {
  src: string;
  thumbnail: string;
  alt: string;
}
@Component({
  selector: 'app-events-father',
  templateUrl: './events-father.component.html',
  styleUrls: ['./events-father.component.scss'],
})
export class EventsFatherComponent {
  images: Image[] = [
    {
      src: 'assets/img/school/events/father/1.jpg',
      thumbnail: 'assets/img/school/events/father/1.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/father/2.jpg',
      thumbnail: 'assets/img/school/events/father/2.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/father/3.jpg',
      thumbnail: 'assets/img/school/events/father/3.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/father/4.jpg',
      thumbnail: 'assets/img/school/events/father/4.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/father/5.jpg',
      thumbnail: 'assets/img/school/events/father/5.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/father/6.jpg',
      thumbnail: 'assets/img/school/events/father/6.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/father/7.jpg',
      thumbnail: 'assets/img/school/events/father/7.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/father/8.jpg',
      thumbnail: 'assets/img/school/events/father/8.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/father/9.jpg',
      thumbnail: 'assets/img/school/events/father/9.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/father/10.jpg',
      thumbnail: 'assets/img/school/events/father/10.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/father/11.jpg',
      thumbnail: 'assets/img/school/events/father/11.jpg',
      alt: 'Image 01',
    },
  ];
}
